import React, {useState} from "react";
import {Col, Row} from "reactstrap";
import {UploadStates, WarrantyAndReturnMessageSenderTypes} from "../../../../../../core/constants/enums";
import IconButton from "../../../../base/button/icon_button";
import {CircularProgress, Fade, SvgIcon} from "@mui/material";
import {ReactComponent as Remove} from "../../../../../../assets/images/remove.svg";
import {Autorenew, CheckCircleOutline, ErrorOutline, Share} from "@mui/icons-material";
import ImagesPreviewModal from "../../../../dialogs/images-preview";
import ElementIds from "../../../../../../core/models/element-ids";
import Utils from "../../../../../../core/services/utils/utils";

const ImageBubble = ({data, removeMessage, sendAgain, className = '', forward, canForward, ...props}) => {
    const [removing, setRemoving] = useState(false);
    const [sending, setSending] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [forwarding, setForwarding] = useState(false);
    const [hover, setHover] = useState(false);

    const isFromUserChat = !!props['old-structure'];
    const forwardedData = data.forwardedMsgInfo;
    const shouldUseOldStructure = isFromUserChat || !!forwardedData;
    const id = forwardedData?.submitDateTime?.toString() ?? data?.submitDateTime?.toString() ?? data.submittedDateTime.toString();


    const isFromSystem = data.senderTypeID === WarrantyAndReturnMessageSenderTypes.system;
    let isFromCurrent = data.senderTypeID === WarrantyAndReturnMessageSenderTypes.operator;
    if (!isFromUserChat) {
        isFromCurrent = !!data.operator;
    }

    /**
     * Determines whether the current image is portrait or
     * @return {boolean}
     */
    const isPortrait = () => {
        const image = document.getElementById(id);
        if (!image) return true;
        return image.clientWidth < image.clientHeight
    }

    /**
     * Shows the preview of the underlying image if the image is uploaded successfully.
     */
    const showImagePreview = () => {
        if (data.uploadState?.state === UploadStates.pending || data.uploadState?.state === UploadStates.error) return;
        setShowPreview(true);
    }

    return (
        <>
            <Row
                id={shouldUseOldStructure
                    ? `${forwardedData?.submitDateTime?.toString() ?? data.submitDateTime?.toString()}-${forwardedData?.typeID ?? data.typeID}`
                    : `${data.submittedDateTime.toString()}-${data.msgType.id}`}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                className={`w-100 no-gutters my-3 ${isFromCurrent ? 'justify-content-end' : 'justify-content-start'} ${className}`}
            >
                {
                    isFromCurrent
                    && !isFromSystem
                    && isFromUserChat
                    && canForward
                    && (
                        <Fade in={hover} unmountOnExit mountOnEnter>
                            <div className={'col justify-content-end align-items-center row no-gutters flex-grow-0'}>
                                <IconButton
                                    className={'mr-1'}
                                    disabled={removing || sending || forwarding}

                                    onPressed={() => forward(data, setForwarding)}
                                    color={'paper.secondary'}
                                >
                                    <Share className={'icon normal'}/>
                                </IconButton>
                            </div>

                        </Fade>
                    )
                }
                {
                    isFromCurrent
                    && !isFromSystem
                    && data.uploadState?.state === UploadStates.done
                    && (
                        <Fade in={hover} unmountOnExit mountOnEnter>
                            <div className={'col justify-content-end align-items-center row no-gutters flex-grow-0'}>
                                <IconButton
                                    className={'mr-2'}
                                    disabled={removing || sending}

                                    onPressed={() => removeMessage(data, setRemoving)}
                                    color={'paper.error'}
                                >
                                    <SvgIcon className={'icon normal'} component={Remove}/>
                                </IconButton>
                            </div>

                        </Fade>
                    )
                }
                <div>
                    <div
                        className={`rounded-xxl p-3 ${isFromCurrent ? 'background-secondary-color-1' : 'background-tertiary'} ${(data.uploadState?.state === UploadStates.pending && data.imageUploadState?.state === UploadStates.pending) ? 'cursor-progress-hover' : data.uploadState?.state === UploadStates.error ? 'cursor-pointer-hover' : 'cursor-default-hover'}`}
                        style={{
                            maxWidth: (document.getElementById(ElementIds.partSupportChat.body)?.clientWidth ?? 100) / 2,
                        }}
                        onClick={showImagePreview}>
                        {isFromCurrent && (data.uploadState?.state === UploadStates.pending || data.uploadState?.state === UploadStates.error)
                            ? <img id={id}
                                   src={data.tempUrl}
                                   alt={`message-at-${data.submitDateTime}`}
                                   className={`text-sm ${isFromCurrent ? "white" : "text-color-1"} ${isPortrait() ? 'portrait' : 'landscape'}`}
                            />
                            : shouldUseOldStructure
                                ? <img
                                    id={id}
                                    src={Utils.encodeFileUrl(forwardedData?.data ?? data.data)}
                                    alt={`message-at-${forwardedData?.submitDateTime ?? data.submitDateTime}`}
                                    className={`text-sm ${isFromCurrent ? "white" : "text-color-1"} ${isPortrait() ? 'portrait' : 'landscape'}`}
                                />
                                : <img
                                    id={id}
                                    src={Utils.encodeFileUrl(data.data)}
                                    alt={`message-at-${data.submittedDateTime}`}
                                    className={`text-sm ${isFromCurrent ? "white" : "text-color-1"} ${isPortrait() ? 'portrait' : 'landscape'}`}
                                />
                        }
                    </div>
                    {
                        !!forwardedData &&
                        <Col
                            xs={12}
                            className={`d-flex p-0 ${isFromCurrent ? 'justify-content-start' : 'justify-content-end'}`}
                        >
                            <p className={'text-xs text-color-3 ml-2 mt-1'}>Forwarded</p>
                        </Col>
                    }
                </div>

                {
                    isFromCurrent
                    && !isFromSystem
                    && (
                        <div className={'d-flex flex-column align-items-end justify-content-end ml-1'}>
                            <Fade
                                in={(data.uploadState?.state === UploadStates.error || data.imageUploadState?.state === UploadStates.error)}
                                unmountOnExit mountOnEnter>
                                <ErrorOutline className={'icon red small'}/>
                            </Fade>
                            <Fade in={data.uploadState?.state === UploadStates.done} unmountOnExit mountOnEnter>
                                <CheckCircleOutline className={'icon stroke-grey-1 small'}/>
                            </Fade>
                            <Fade
                                in={(data.uploadState?.state === UploadStates.pending || data.imageUploadState?.state === UploadStates.pending)}
                                unmountOnExit mountOnEnter>
                                <CircularProgress color={'secondary'} size={15}/>
                            </Fade>
                        </div>
                    )
                }
                {
                    !isFromCurrent
                    && !isFromSystem
                    && isFromUserChat
                    && canForward
                    && data.uploadState?.state === UploadStates.done
                    && (
                        <Fade in={hover} unmountOnExit mountOnEnter>
                            <div className={'col justify-content-end align-items-center row no-gutters flex-grow-0'}>
                                <IconButton
                                    className={'ml-1'}
                                    disabled={removing || sending || forwarding}

                                    onPressed={() => forward(data, setForwarding)}
                                    color={'paper.secondary'}
                                >
                                    <Share className={'icon normal'}/>
                                </IconButton>
                            </div>

                        </Fade>
                    )
                }
                {
                    !isFromCurrent
                    && !isFromSystem
                    && data.uploadState?.state === UploadStates.done
                        ? (
                            <Fade in={hover} unmountOnExit mountOnEnter>
                                <div className={'col justify-content-end align-items-center row no-gutters flex-grow-0'}>
                                    <IconButton
                                        className={'ml-2'}
                                        disabled={removing || sending}

                                        onPressed={() => removeMessage(data, setRemoving)}
                                        color={'paper.error'}
                                    >
                                        <SvgIcon className={'icon normal'} component={Remove}/>
                                    </IconButton>
                                </div>
                            </Fade>
                        )
                        : isFromCurrent
                        && !isFromSystem
                        && data.uploadState?.state === UploadStates.error
                        && (
                            <Fade
                                in={(data.uploadState?.state === UploadStates.error || data.imageUploadState.state === UploadStates.error) && hover}
                                unmountOnExit mountOnEnter>
                                <div className={'col justify-content-end align-items-center row no-gutters flex-grow-0'}>
                                    <IconButton
                                        className={'ml-2'}
                                        disabled={sending || removing}

                                        onPressed={() => sendAgain(data, setSending)}
                                        color={'paper.secondary'}
                                    >
                                        <Autorenew className={'icon normal'}/>
                                    </IconButton>
                                </div>
                            </Fade>
                        )
                }
            </Row>
            <ImagesPreviewModal
                setOpen={() => setShowPreview(false)}
                images={[{src: forwardedData?.data ?? data.data, alt: 'chat image'}]}
                open={showPreview}
            />
        </>
    );
}

export default ImageBubble;
